module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_4.137a6bc4.png";